import React, { useState } from 'react'
import { Pager as KPager, PageChangeEvent } from "@progress/kendo-react-data-tools";

interface IPagerProps {
  total: number;
  handlePageChange: (pageState: any) => void;
}

const Pager = (props: IPagerProps) => {
  const { total } = props;

  interface PagerState {
    skip: number;
    take: number;
    buttonCount: number;
    type: "numeric" | "input";
    info: boolean;
    pageSizes: boolean;
    previousNext: boolean;
    responsive: boolean;
  }

  const initialPageState: PagerState = {
    skip: 0,
    take: 5,
    buttonCount: 5,
    type: 'numeric',
    info: true,
    pageSizes: true,
    previousNext: true,
    responsive: true,
  };


  const [pageState, setPageState] = useState(initialPageState);
  const [pageSizes, setPageSizes] = useState<number[]>([5, 10, 20]);

  let { skip, take } = pageState;

  const handlePageChange = (event: PageChangeEvent) => {
    const { skip, take } = event;
    setPageState({ ...pageState, skip: skip, take: take });
    props.handlePageChange({ ...pageState, skip: skip, take: take });
  }

  return (
    <KPager
      skip={skip}
      take={take}
      total={total}
      buttonCount={pageState.buttonCount}
      info={pageState.info}
      type={pageState.type}
      pageSizes={pageState.pageSizes ? pageSizes : undefined}
      previousNext={pageState.previousNext}
      onPageChange={handlePageChange}
    />
  )
}

export default Pager